import { apiRequestToken } from '../Utilidades/apiRequest';
import { ComentarioRequest } from '../interfaces/comentariosInterfaces';

export const crearComentario = async (comentarioRequest: ComentarioRequest) => {
    return apiRequestToken({
        endpoint: 'comentarios/nuevo',
        body: comentarioRequest,
        method: 'POST',
    })
};


export const consultarComentarios = async (idComunicado:number) => {
    return apiRequestToken({
        endpoint: `comentarios/${idComunicado}`,
        method: 'GET',
    })
};

export const activarDesactivarComentario = async (id: number) => {
    return apiRequestToken({
        endpoint: `comentarios/${id}`,
        method: 'PUT',
    })
};